import type { ColumnType, ColumnsType } from "antd/es/table"
import type { Key } from "react"

type TableOrderingSorter = {
  field?: Key | readonly Key[]
  order?: "ascend" | "descend" | string | null
}

export const getTableOrderingFromSorter = (
  sorter?: TableOrderingSorter | TableOrderingSorter[] | null
): string | null => {
  if (!sorter) return null

  if (Array.isArray(sorter)) {
    return sorter
      ?.map(({ field, order }) => (order === "ascend" ? field : `-${field}`))
      .join(",")
  } else {
    if (sorter.order) {
      return sorter.order === "ascend"
        ? (sorter.field as string)
        : `-${sorter.field}`
    }
  }

  return null
}

const dataIndexOf = <T>(column: ColumnsType<T>[number]): string | null => {
  const dataIndex = (column as ColumnType<T>).dataIndex
  return typeof dataIndex === "string" ? dataIndex : null
}

// A table given a server ordering shows it on the header it came from; without
// this a list that opens already sorted looks unsorted.
export const withSortOrder = <T>(
  columns: ColumnsType<T>,
  ordering: string | null
): ColumnsType<T> => {
  if (!ordering) return columns
  const descending = ordering.startsWith("-")
  const field = descending ? ordering.slice(1) : ordering
  return columns.map((column) => {
    if (!(column as ColumnType<T>).sorter) return column
    const active = dataIndexOf(column) === field
    return {
      ...column,
      sortOrder: active ? (descending ? "descend" : "ascend") : null
    }
  })
}
